import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet';

import { BreadcrumbSetter } from '@/components/BreadcrumbSetter';
import { StoreNavBar } from '@/components/store/StoreNavBar';
import { useStore } from '@/hooks/data/useStore';

export const Route = createFileRoute('/store')({
	component: function StoreLayout() {
		const { data: store } = useStore();
		return (
			<div>
				<StoreNavBar />
				<Outlet />
				<Helmet titleTemplate={`%s - ${store?.name}`} defaultTitle={`${store?.name} - SideDish`} />
				<BreadcrumbSetter items={[]} />
			</div>
		);
	},
});
